/* eslint-disable camelcase */
import { LocationMapper } from '@nx-smartmonkey/shared/domain';
import { RouteStopFieldProps, Stop } from '../domain/stop/Stop';
import { StopRepositoryDTO } from '../domain/stop/StopRepositoryDTO';
import { StopTask } from '../domain/stop/StopTask';
import { StopEntry } from '../entries/StopEntry';
import { StopReportMapper } from './report/StopReportMapper';

class StopMapper {
  static toDomain(props: StopEntry): Stop {
    const {
      id,
      label,
      route_id,
      type,
      status,
      pickup_id,
      location,
      report,
      order,
      tasks,
      customer_text_field,
      stop_fields,
      optimization_warning,
      planned_arrival_time,
      estimated_arrival_time,
    } = props;

    return Stop.create(
      {
        label,
        route_id,
        stop_fields,
        status,
        type,
        pickup_id,
        location: location ? LocationMapper.toDomain(location) : undefined,
        customer_text_field,
        order,
        report: report ? StopReportMapper.toDomain(report) : undefined,
        tasks: tasks.map(({ id, ...task }) =>
          StopTask.create(
            {
              stop_id: task.stop_id,
              label: task.label,
              status: task.status,
              fields: task.fields,

              // CRUD
              created_at: task.created_at,
            },
            id
          )
        ),
        optimization_warning,
        planned_arrival_time,
        estimated_arrival_time,
      },
      id
    );
  }

  static toRepository(stop: Stop): StopRepositoryDTO {
    const filterEditableFields = (field: RouteStopFieldProps) => {
      const notAllowedFields = [`estimated_arrival_time`, `planned_arrival_time`];
      return field.value !== undefined && (field.is_custom_field || !notAllowedFields.includes(field.id));
    };
    const removeLabelAndTypeFromFields = (field: RouteStopFieldProps) => {
      const { label, type, ...other } = field;
      return other;
    };
    return {
      label: stop.label,
      ...(stop.location ? { location: LocationMapper.toDTO(stop.location) } : {}),
      stop_fields: stop.stop_fields.filter(filterEditableFields).map(removeLabelAndTypeFromFields),
    };
  }
}

export default StopMapper;
